import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import memoizeOne from 'memoize-one';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import SwipeableViews from 'react-swipeable-views';
import PanelContainer from './PanelContainer.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'prop-types';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var blockName = 'tabs-panels';
var Panels = aggregatedClasses('div')(blockName);

var getIndexById = function getIndexById(children, activeId) {
  return children && children.findIndex(function (item) {
    return item.props.tabId === activeId;
  });
};

var getIdByIndex = function getIdByIndex(children, index) {
  return children && children[index].props.tabId;
};

var TabsPanels = /*#__PURE__*/function (_Component) {
  _inherits(TabsPanels, _Component);

  var _super = _createSuper(TabsPanels);

  function TabsPanels() {
    var _this;

    _classCallCheck(this, TabsPanels);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderPanels", memoizeOne(function (activeTab, tabsComponents) {
      var _this$props = _this.props,
          animated = _this$props.animated,
          onlyRenderActiveTab = _this$props.onlyRenderActiveTab,
          allowTextSelection = _this$props.allowTextSelection;
      return React.Children.map(tabsComponents, function (tab) {
        var _tab$props = tab.props,
            panelId = _tab$props.tabId,
            style = _tab$props.style,
            content = _tab$props.children;
        var isActive = activeTab === panelId;
        var shouldRender = !onlyRenderActiveTab || isActive;
        return /*#__PURE__*/React.createElement(PanelContainer, {
          key: panelId,
          "aria-labelledby": "".concat(panelId, "-label"),
          lastTabRef: _this.props.lastTabRef,
          firstSubtabRef: _this.props.firstTabRefByParent,
          classProps: {
            isActive: isActive
          },
          "data-panel-id": panelId,
          hidden: !animated && !isActive,
          onMouseDown: function onMouseDown(e) {
            var role = e.target.getAttribute('role');
            if (role !== 'tabpanel' && allowTextSelection) e.stopPropagation();
          },
          role: "tabpanel",
          style: style
        }, shouldRender && content);
      }, null);
    }));

    return _this;
  }

  _createClass(TabsPanels, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          activeTab = _this$props2.activeTab,
          tabsComponents = _this$props2.tabsComponents,
          animated = _this$props2.animated,
          onTabChange = _this$props2.onTabChange,
          enableMouseEvents = _this$props2.enableMouseEvents;
      var panels = animated ? /*#__PURE__*/React.createElement(SwipeableViews, {
        enableMouseEvents: enableMouseEvents,
        index: getIndexById(tabsComponents, activeTab),
        onChangeIndex: function onChangeIndex(index) {
          return onTabChange(getIdByIndex(tabsComponents, index));
        }
      }, this.renderPanels(activeTab, tabsComponents)) : this.renderPanels(activeTab, tabsComponents);
      return /*#__PURE__*/React.createElement(Panels, null, panels);
    }
  }]);

  return TabsPanels;
}(Component);

export default TabsPanels;
//# sourceMappingURL=TabsPanels.js.map
